import api from './api';

/** Unblinded ≡ Open Label (same as StudyDesignVisitLaneHelper / StudyVisitTypeService). */
function normalizeStudyDesign(desc) {
  const s = (desc || '').toString().trim().toLowerCase();
  if (!s) return '';
  if (s === 'unblinded' || s.includes('open label')) return 'open label';
  return s;
}

const UNBLINDED_SESSION_PROFILES = new Set(['UCRA', 'UPM', 'USRM', 'UVWR']);

const userService = {
  /**
   * @param {string} role e.g. "PM" or "UPM"
   * @param {string} [projectCode] when set, only users with UserRoleProjectSiteMapping for this project (code or nProjectNo)
   * @param {number|string} [siteNo] when set, project-wide PM (null site on mapping) or PM mapped to this site (SiteNo)
   */
  async getByRole(role, projectCode, siteNo) {
    const params = {};
    if (projectCode != null && String(projectCode).trim() !== '') {
      params.projectCode = String(projectCode).trim();
    }
    if (siteNo != null && siteNo !== '' && !Number.isNaN(Number(siteNo))) {
      params.siteNo = String(siteNo);
    }
    const response = await api.get(`/users/role/${encodeURIComponent(role)}`, { params });
    return response.data;
  },

  /**
   * Lane-aware PM role for Confirm Letter: Open Label / Unblinded visit → UPM; Double Blind → PM.
   * Falls back to session profile when visit type design is unknown.
   */
  async resolvePmRoleForVisitLane(visit, user) {
    const visitType = (visit?.visitType ?? visit?.VisitType ?? '').toString().trim().toUpperCase();
    if (visitType) {
      try {
        const res = await api.get('/study-configuration/visit-types');
        const rows = Array.isArray(res.data) ? res.data : [];
        const match = rows.find(
          (v) => String(v.visitCode || v.VisitCode || '').trim().toUpperCase() === visitType,
        );
        const design = normalizeStudyDesign(match?.studyDesignDesc ?? match?.StudyDesignDesc);
        if (design === 'open label') return 'UPM';
        if (design.includes('double blind') || design === 'blinded') return 'PM';
      } catch {
        /* fall through to session */
      }
    }

    const profile = (
      user?.profileCode ?? user?.vUserTypeCode ?? user?.role ?? user?.Role ?? ''
    )
      .toString()
      .trim()
      .toUpperCase();
    if (UNBLINDED_SESSION_PROFILES.has(profile)) return 'UPM';

    const sessionDesign = normalizeStudyDesign(
      user?.studyDesignDesc ?? user?.vStudyDesignDesc,
    );
    if (sessionDesign === 'open label') return 'UPM';

    return 'PM';
  },
};

export default userService;

